import { useMemo } from 'preact/hooks'

export const useLenghts = ({
    variantLength,
    productUrl
}) => {
    return useMemo(() => {
        if (!variantLength) {
            return []
        } else {
            const variantLengthArray = typeof(variantLength) === 'object' ? variantLength : variantLength.split("|");
            const lengthList = new Set();
            variantLengthArray.forEach(length => {
              let lengths = new Object();
              lengths.length = length.trim();
              lengthList.add(lengths);
            }); 
            return lengthList
        }
    }, [
        variantLength,
        productUrl
    ])
}
